interface UIModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  /** Tailwind width class (e.g. 'max-w-lg', 'w-[500px]') */
  width?: string;
  /** Tailwind height class (e.g. 'h-[600px]', 'h-auto') */
  height?: string;
  /** Optional: control padding or remove it completely */
  padding?: string;
}

const CommonModal = ({
  isOpen,
  onClose,
  children,
  width,
  height,
  padding,
}: UIModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
      <div
        className={`relative ${width} ${height} rounded-[20px] border-[1px] border-[#E4FFFB] bg-white shadow-[0_2px_24px_0_rgba(35,105,142,0.08)] ${padding} shadow-xl transition-all duration-300`}
      >
        {/* Close Button */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute right-4 top-4 rounded-full bg-primary/20 px-3 py-2 font-bold text-secondary hover:text-gray-700"
          >
            ✕
          </button>
        )}

        {/* Modal Content */}
        <div className="max-h-[90vh] overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

export default CommonModal;
